export default class RacunalnikObj {
    ratings = [
        [30,	10],
        [65,    15],	
        [225,	3],
        [235,	1],
        [245,	1],
        [255,	1],
        [230,	1],
        [290,	3],
        [315,	4],
        [330,	4],
    ];

    strings = [
        "Prenosni računalnik 12 do 14-palčni zaslon",
        "Prenosni računalnik 15 do 17-palčni zaslon",
        "Namizni računalnik + 17-palčni lcd zaslon",
        "Namizni računalnik + 19-palčni lcd zaslon",
        "Namizni računalnik + 22-palčni lcd zaslon",
        "Namizni računalnik + 24-palčni lcd zaslon",
        "Namizni računalnik + 24-palčni lcd led zaslon",
        "Namizni računalnik + 17-palčni crt zaslon",
        "Namizni računalnik + 19-palčni crt zaslon",
        "Namizni računalnik + 21-palčni crt zaslon",
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    ukrep5;
    ukrep5_savings;

    constructor(tip, teden, vikend) {
        this.st_select = 7;
        this.short = "R";
        this.st_ukrepov = 0;
        this.name = "Računalnik";

        this.tip = tip;
        this.teden = teden;
        this.vikend = vikend;

        this.curr_use = this.ratings[tip - 1][1] * 5 + this.ratings[tip - 1][1] * 19 * 365 / 1000;

        this.detail_string = this.strings[this.tip - 1];
    }
}